import React from "react";
import { Link } from "react-router-dom";
import heroImage from "../../assets/images/products/bag3.jpg";
import gridImage1 from "../../assets/images/products/bag2.jpg";
import gridImage2 from "../../assets/images/products/bag1.jpg";
import gridImage4 from "../../assets/images/products/bag4.jpg";
const AboutPage = () => {
  return (
    <div className="bg-white text-gray-800">
      <div
        className="relative w-full h-[150px] sm:h-[200px] md:h-[250px] mb-3 bg-cover bg-center overflow-hidden"
        style={{
          backgroundImage: `url(${require("../../assets/images/products/bag3.jpg")})`,
        }}
      >
        {/* Black overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-30 flex flex-col items-center justify-center text-white text-center p-4">
          {/* Page Title */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-2 uppercase tracking-wide">
            ABOUT US
          </h2>

          {/* Breadcrumb */}
          <nav className="flex items-center space-x-2 text-sm text-gray-200 bg-black/40 px-4 py-2 rounded-md max-w-fit mx-auto">
            <Link to="/" className="hover:text-white">
              Home
            </Link>
            <span>/</span>
            <span>About Us</span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* ====== Our Story Section ====== */}
        <section className="max-w-3xl mx-auto text-center px-4 mb-20 mt-10">
          <h2 className="text-2xl font-semibold tracking-[0.2em] uppercase mb-6">
            OUR STORY
          </h2>
          <div className="text-gray-600 space-y-4 leading-relaxed">
            <p>
              At Luggaelegacy, we feel that handbags are not just accessories.
              They are much more than that. That's why we go beyond crafting
              beautiful bags – we craft experiences.
            </p>
            <p>
              A Luggaelegacy is not just a bag on your arm – it's a feeling. It's
              the confidence that comes with knowing you look polished and put
              together. It's the empowerment that lets you conquer your day,
              knowing you have a reliable companion by your side.
            </p>
          </div>
        </section>

        {/* ====== Two-Column Image Grid Section ====== */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-12">
          <img
            src={gridImage1}
            alt="Fashion items on a clothing rack"
            className="w-full h-auto object-cover"
          />
          <img
            src={gridImage2}
            alt="Contents of a black handbag"
            className="w-full h-auto object-cover"
          />
        </section>

        {/* ====== Mission & Vision Text Section ====== */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto text-center px-4 mb-24">
          {/* Mission */}
          <div>
            <h3 className="text-xl font-semibold tracking-[0.2em] uppercase mb-4">
              MISSION
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Our mission is to empower you to express yourself through fashion
              without compromising on quality. We are committed to delivering
              high-quality, trending products at an accessible price point.
            </p>
          </div>
          {/* Vision */}
          <div>
            <h3 className="text-xl font-semibold tracking-[0.2em] uppercase mb-4">
              VISION
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Our vision is to become a global leader by making premium,
              trendsetting products accessible to a larger set of audiences,
              redefining everyday luxury and style.
            </p>
          </div>
        </section>
      </div>

      {/* ====== Attention to Detail Section (Parallax) ====== */}
      <section
        className="h-[75vh] bg-cover bg-center bg-fixed relative flex items-center justify-center text-center mb-10"
        style={{
          backgroundImage: `url(${gridImage4})`,
        }}
      >
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="relative z-10 text-white max-w-xl px-6">
          <h3 className="text-xl font-semibold tracking-[0.2em] uppercase mb-6">
            ATTENTION TO DETAIL
          </h3>
          <p className="leading-relaxed text-lg">
            We carefully craft each piece with utmost care. By keeping the
            modern person in mind, we understand your need for empowerment,
            style, and functionality. So, every stitch, every pocket, and every
            curve is thoughtfully constructed to seamlessly integrate into your
            life.
          </p>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
